import { useCallback, useContext, useEffect, useState } from 'react';
import ByClassProgressNoteContainer from './ByClassProgressNoteContainer';
import GradeContext from '../../contexts/grade';
import UserContext from '../../contexts/userContext';
import axios from '../../../node_modules/axios/index';
import PageContainer from '../../pageLayout/PageContainer';
import { PageBox, PageSubheader } from '../../pageLayout/PageContainerStyle';
import ClassProgressnoteMenu from '../../topSubMenuBar/ClassProgressnoteMenu';
import { useMediaQuery } from 'react-responsive';
import MobileTopMenuBar from '../../topMenuBarMobile/MobileTopMenuBar';
import MobileTopMenuBarProgressNote from '../../topMenuBarMobile/MobileTopMenuBarProgressNote';
import Notification from '../../components/Notification';
import { notificationTime } from '../../styles/commonStyle';
import { useNavigate } from '../../../node_modules/react-router-dom/dist/index';
import {
  DisplayColumn,
  DisplayRowSpaceBetween,
  TitleContainer,
  TitleDetail,
  TitleText,
} from '../../styles/BasicStyle';
import { OneByOneButton } from '../../seatdrawpages/3drawOneByOnePage/OneByOneStyle';
import RegisterModalComponent from '../registerModal/RegisterModalComponent';
import LoginModalComponent from '../loginModal/LoginModalComponent';
import { ProgressNoteHelmetContent } from '../../components/HelmetContent';

const ByClassProgressNotePage = () => {
  //현재 학년, user context 받아오기
  const { state: gradeState } = useContext(GradeContext);
  const { state: userState } = useContext(UserContext);
  const userId = userState && userState.user ? userState.user.userId : null;
  const grade = gradeState.currentGrade;

  const [showAddWindow, setShowAddWindow] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [showSampleNotification, setShowSampleNotification] = useState(false);

  //---------------- 기본 데이터 세팅  ----------------//
  //progressNote 데이터 받아오기 : 학년별 진도 노트 데이터 가져오기
  const [progressNoteByGradeDB, setProgressNoteByGradeDB] = useState([]);

  const fetchProgressNoteByGrade = useCallback(async () => {
    if (!userId) {
      setProgressNoteByGradeDB([
        {
          id: 204,
          userId: 'teachernote',
          grade: 2,
          classNum: 1,
          topicNum: 1,
          record:
            '이번 수업에서는 비유와 상징을 활용한 문학 작품을 분석하며 그 표현 효과를 탐구했다. 학생들은 비유와 상징의 의미를 이해하고 이를 통해 작품의 깊이와 풍부함을 체험했다. 특히 시에서 사용된 다양한 비유 표현을 통해 감정과 분위기를 어떻게 전달하는지에 대한 이해가 깊어졌다. 학생들은 자신들이 작성한 글에서도 비유와 상징을 활용해 보는 활동을 즐겼다. 앞으로는 학생들이 좀 더 창의적으로 비유와 상징을 사용할 수 있도록 다양한 예시를 제공할 예정이다.',
          createdAt: '2024-07-02T03:41:09.000Z',
          updatedAt: '2024-07-01T18:41:09.000Z',
        },
        {
          id: 211,
          userId: 'teachernote',
          grade: 2,
          classNum: 1,
          topicNum: 6,
          record:
            '이번 수업에서는 텍스트를 읽으면서 앞으로의 내용을 예측하는 방법에 대해 배웠다. 학생들은 단서와 맥락을 통해 다음 전개를 추측하며 읽는 활동을 진행했다. 특히 예측을 통해 독해력을 향상시키는 방법을 체험하며 독서의 즐거움을 느꼈다. 수업 후반부에는 각자 예측한 내용을 토대로 이야기를 창작하는 활동을 했다. 앞으로는 더욱 다양한 텍스트를 활용해 예측하며 읽는 능력을 키울 예정이다.',
          createdAt: '2024-07-08T00:54:51.000Z',
          updatedAt: '2024-07-07T15:54:46.000Z',
        },
        {
          id: 205,
          userId: 'teachernote',
          grade: 2,
          classNum: 2,
          topicNum: 2,
          record:
            '수업에서는 문학 작품 속 갈등의 종류와 해결 과정을 분석하며, 갈등의 중요성을 이해하는 시간을 가졌다. 학생들은 갈등이 이야기 전개에 어떻게 기여하는지에 대해 토론하고 발표했다. 특히 인물 간의 갈등과 내적 갈등을 비교하며 서로 다른 해결 방법에 대해 고민했다. 학생들은 작품 속 갈등 상황을 재현해 보며 보다 생생하게 이해할 수 있었다. 다음 수업에서는 학생들이 직접 갈등 상황을 설정하고 해결하는 글쓰기를 통해 창의성을 발휘할 수 있도록 할 계획이다.',
          createdAt: '2024-07-08T00:53:33.000Z',
          updatedAt: '2024-07-07T15:53:26.000Z',
        },
        {
          id: 213,
          userId: 'teachernote',
          grade: 2,
          classNum: 2,
          topicNum: 7,
          record:
            '이번 수업에서는 텍스트의 핵심 내용을 요약하는 방법에 대해 학습했다. 학생들은 주요 내용을 파악하고 이를 간결하게 정리하는 방법을 연습했다. 특히 긴 글을 읽고 중요한 정보를 추려내는 활동을 통해 요약 능력을 향상시켰다. 학생들은 각자 읽은 내용을 친구들과 공유하며 요약의 중요성을 체험했다. 앞으로는 더욱 복잡한 텍스트를 요약하는 연습을 통해 학생들의 독해력을 높일 계획이다.',
          createdAt: '2024-07-08T00:55:14.000Z',
          updatedAt: '2024-07-07T15:55:11.000Z',
        },
        {
          id: 206,
          userId: 'teachernote',
          grade: 2,
          classNum: 3,
          topicNum: 3,
          record:
            '이번 수업에서는 문학 작품을 통해 삶을 성찰하는 방법에 대해 학습했다. 학생들은 작품 속 인물의 경험과 자신의 경험을 비교하며 삶의 의미를 깊이 생각해보았다. 특히 특정 사건이 인물에게 미친 영향을 분석하면서 자신에게도 비슷한 상황이 있었는지 돌아보는 시간을 가졌다. 수업 후반부에는 자신의 삶을 문학적으로 표현해보는 활동을 진행했다. 앞으로는 다양한 문학 작품을 통해 학생들이 더 많은 삶의 교훈을 얻을 수 있도록 할 계획이다.',
          createdAt: '2024-07-08T00:53:42.000Z',
          updatedAt: '2024-07-07T15:53:36.000Z',
        },
        {
          id: 214,
          userId: 'teachernote',
          grade: 2,
          classNum: 3,
          topicNum: 8,
          record:
            '이번 수업에서는 다양한 자료를 활용해 읽는 방법에 대해 배웠다. 학생들은 그래프, 표, 그림 등 시각적 자료를 통해 정보를 얻는 방법을 학습했다. 특히 자료를 통해 텍스트의 내용을 보완하고 이해하는 활동을 진행했다. 학생들은 자료를 분석하고 이를 토대로 자신의 의견을 작성하는 연습을 즐겼다. 앞으로는 다양한 자료를 활용해 읽기 능력을 더욱 향상시킬 예정이다.',
          createdAt: '2024-07-08T00:55:22.000Z',
          updatedAt: '2024-07-07T15:55:19.000Z',
        },
        {
          id: 207,
          userId: 'teachernote',
          grade: 2,
          classNum: 4,
          topicNum: 4,
          record:
            '이번 수업에서는 언어의 본질과 국어의 어휘 체계에 대해 배웠다. 학생들은 국어의 다양한 어휘가 어떻게 구성되고 사용되는지에 대해 깊이 이해했다. 특히 동일한 단어가 문맥에 따라 다르게 해석될 수 있음을 배우며 언어의 유연성을 체험했다. 학생들은 다양한 어휘를 활용해 자신의 생각을 표현하는 활동을 통해 어휘력 향상의 중요성을 깨달았다. 앞으로는 학생들이 더욱 다양한 어휘를 접하고 사용할 수 있는 기회를 제공할 예정이다.',
          createdAt: '2024-07-08T00:53:50.000Z',
          updatedAt: '2024-07-07T15:53:48.000Z',
        },
        {
          id: 215,
          userId: 'teachernote',
          grade: 2,
          classNum: 4,
          topicNum: 9,
          record:
            '이번 수업에서는 자신의 경험을 바탕으로 글을 쓰는 방법에 대해 배웠다. 학생들은 자신의 경험을 생생하게 전달하기 위해 구체적인 사례와 감정을 담아 글을 작성했다. 특히 글의 통일성을 유지하는 방법을 학습하며 일관된 주제로 글을 전개하는 연습을 했다. 학생들은 서로의 글을 읽고 피드백을 주고받으며 글쓰기 능력을 향상시켰다. 앞으로는 더욱 다양한 주제로 글을 쓰며 학생들의 표현력을 키울 계획이다.',
          createdAt: '2024-07-08T00:55:34.000Z',
          updatedAt: '2024-07-07T15:55:29.000Z',
        },
        {
          id: 208,
          userId: 'teachernote',
          grade: 2,
          classNum: 5,
          topicNum: 5,
          record:
            '이번 수업에서는 국어의 품사와 그 특성에 대해 학습했다. 학생들은 각 품사가 문장에서 어떤 역할을 하는지에 대해 이해했다. 특히 명사, 동사, 형용사의 활용법을 집중적으로 학습하며 문장을 구성하는 기본 원리를 깨달았다. 학생들은 예문을 통해 다양한 품사를 활용해 문장을 구성하는 활동을 즐겼다. 앞으로는 더욱 복잡한 문장 구조를 다루며 학생들의 문장 구성 능력을 향상시킬 계획이다.',
          createdAt: '2024-07-08T00:53:57.000Z',
          updatedAt: '2024-07-07T15:53:55.000Z',
        },
        {
          id: 216,
          userId: 'teachernote',
          grade: 2,
          classNum: 5,
          topicNum: 10,
          record:
            '이번 수업에서는 다양한 매체의 특성에 맞춰 표현하는 방법을 배웠다. 학생들은 글, 영상, 음성 등 여러 매체를 활용해 메시지를 전달하는 방법을 학습했다. 특히 각 매체의 장단점을 비교하며 상황에 맞는 매체를 선택하는 능력을 길렀다. 학생들은 자신이 선택한 매체로 프로젝트를 완성하며 창의성을 발휘했다. 앞으로는 더욱 다양한 매체를 활용한 표현 활동을 통해 학생들의 표현력을 키울 예정이다.',
          createdAt: '2024-07-08T00:55:49.000Z',
          updatedAt: '2024-07-07T15:55:44.000Z',
        },
      ]);
    } else {
      try {
        const res = await axios.get(
          'https://teachernote.me/api/progressnote/' + userId,
          {
            params: { grade: gradeState.currentGrade },
          },
        );
        setProgressNoteByGradeDB(res.data);
        // console.log(JSON.stringify(res.data.length));
        if (res.data.length < 1) {
          setProgressNoteByGradeDB([
            {
              id: 204,
              userId: 'teachernote',
              grade: 2,
              classNum: 1,
              topicNum: 1,
              record:
                '(샘플)이번 수업에서는 비유와 상징을 활용한 문학 작품을 분석하며 그 표현 효과를 탐구했다. 학생들은 비유와 상징의 의미를 이해하고 이를 통해 작품의 깊이와 풍부함을 체험했다. 특히 시에서 사용된 다양한 비유 표현을 통해 감정과 분위기를 어떻게 전달하는지에 대한 이해가 깊어졌다. 학생들은 자신들이 작성한 글에서도 비유와 상징을 활용해 보는 활동을 즐겼다. 앞으로는 학생들이 좀 더 창의적으로 비유와 상징을 사용할 수 있도록 다양한 예시를 제공할 예정이다.',
              createdAt: '2024-07-02T03:41:09.000Z',
              updatedAt: '2024-07-01T18:41:09.000Z',
            },
          ]);
        }
        // await console.log('progressNoteByGradeDB:' + JSON.stringify(res.data));
      } catch (err) {
        console.log(err);
      }
    }
  }, [grade, userId]);

  useEffect(() => {
    fetchProgressNoteByGrade();
  }, [fetchProgressNoteByGrade, userId]);

  // console.log('progressNoteByGradeDB:' + JSON.stringify(progressNoteByGradeDB));

  const sortedProgressNoteByGradeDB = progressNoteByGradeDB.sort((a, b) => {
    if (a.topicNum !== b.topicNum) {
      return a.topicNum - b.topicNum; // topicNum이 다른 경우 오름차순 정렬
    } else {
      return a.classNum - b.classNum; // 같은 topicNum 안에서 classNum 오름차순 정렬
    }
  });

  //topics 테이블 데이터 받아오기- 학년별 수업 주제
  const [topicsDB, setTopicsDB] = useState([]);
  useEffect(() => {
    const fetchTopicsByGrade = async () => {
      if (!userId) {
        setTopicsDB([
          {
            id: 6025,
            userId: 'teachernote',
            grade: 2,
            topicId: 1,
            topicTitle: '비유와 상징의 표현 효과',
            topicDetail: null,
            createdAt: '2024-07-02T03:40:43.000Z',
            updatedAt: '2024-07-02T03:40:43.000Z',
          },
          {
            id: 6026,
            userId: 'teachernote',
            grade: 2,
            topicId: 2,
            topicTitle: '갈등의 진행과 해결 과정',
            topicDetail: null,
            createdAt: '2024-07-02T03:40:43.000Z',
            updatedAt: '2024-07-02T03:40:43.000Z',
          },
          {
            id: 6027,
            userId: 'teachernote',
            grade: 2,
            topicId: 3,
            topicTitle: '문학과 삶의 성찰',
            topicDetail: null,
            createdAt: '2024-07-02T03:40:43.000Z',
            updatedAt: '2024-07-02T03:40:43.000Z',
          },
          {
            id: 6028,
            userId: 'teachernote',
            grade: 2,
            topicId: 4,
            topicTitle: '언어의 본질과 국어의 어휘 체계',
            topicDetail: null,
            createdAt: '2024-07-02T03:40:43.000Z',
            updatedAt: '2024-07-02T03:40:43.000Z',
          },
          {
            id: 6029,
            userId: 'teachernote',
            grade: 2,
            topicId: 5,
            topicTitle: '국어의 품사와 특성',
            topicDetail: null,
            createdAt: '2024-07-02T03:40:43.000Z',
            updatedAt: '2024-07-02T03:40:43.000Z',
          },
          {
            id: 6030,
            userId: 'teachernote',
            grade: 2,
            topicId: 6,
            topicTitle: '예측하며 읽기',
            topicDetail: null,
            createdAt: '2024-07-02T03:40:43.000Z',
            updatedAt: '2024-07-02T03:40:43.000Z',
          },
          {
            id: 6031,
            userId: 'teachernote',
            grade: 2,
            topicId: 7,
            topicTitle: '요약하며 읽기',
            topicDetail: null,
            createdAt: '2024-07-02T03:40:43.000Z',
            updatedAt: '2024-07-02T03:40:43.000Z',
          },
          {
            id: 6032,
            userId: 'teachernote',
            grade: 2,
            topicId: 8,
            topicTitle: '자료 활용하며 읽기',
            topicDetail: null,
            createdAt: '2024-07-02T03:40:43.000Z',
            updatedAt: '2024-07-02T03:40:43.000Z',
          },
          {
            id: 6033,
            userId: 'teachernote',
            grade: 2,
            topicId: 9,
            topicTitle: '경험을 담은 글과 통일성을 갖춘 글 쓰기',
            topicDetail: null,
            createdAt: '2024-07-02T03:40:43.000Z',
            updatedAt: '2024-07-02T03:40:43.000Z',
          },
          {
            id: 6034,
            userId: 'teachernote',
            grade: 2,
            topicId: 10,
            topicTitle: ' 매체 특성에 따른 표현하기',
            topicDetail: null,
            createdAt: '2024-07-02T03:40:43.000Z',
            updatedAt: '2024-07-02T03:40:43.000Z',
          },
          {
            id: 6035,
            userId: 'teachernote',
            grade: 2,
            topicId: 11,
            topicTitle: '면담하기와 배려하는 말하기',
            topicDetail: null,
            createdAt: '2024-07-02T03:40:43.000Z',
            updatedAt: '2024-07-02T03:40:43.000Z',
          },
          {
            id: 6036,
            userId: 'teachernote',
            grade: 2,
            topicId: 12,
            topicTitle: '토의하기와 판단하며 듣기',
            topicDetail: null,
            createdAt: '2024-07-02T03:40:43.000Z',
            updatedAt: '2024-07-02T03:40:43.000Z',
          },
        ]);
      } else {
        try {
          const res = await axios.get(
            'https://teachernote.me/api/topicsbygrade/' + userId,
            {
              params: { grade: gradeState.currentGrade }, // 올바른 요청 옵션 사용
            },
          );
          await setTopicsDB(res.data);
          // console.log('topicsDB' + JSON.stringify(topicsDB));
        } catch (err) {
          console.log(err);
        }
      }
    };
    fetchTopicsByGrade();
  }, [gradeState.currentGrade, userId]);

  //classinfo 데이터 받아오기 (학년 별 classinfo) by user
  const [classInfoByGradeDB, setClassInfoclassInfoByGradeDB] = useState([]);
  useEffect(() => {
    const fetchClassInfoByGrade = async () => {
      try {
        const res = await axios.get(
          'https://teachernote.me/api/classinfobygrade/' + userId,
          {
            params: { grade: grade },
          },
        );
        await setClassInfoclassInfoByGradeDB(res.data);
      } catch (err) {
        console.log(err);
      }
    };
    fetchClassInfoByGrade();
  }, [userId, grade]);

  //classinfo 데이터 받아오기 (전체 학년 classinfo) by user
  const [classInfoDB, setClassInfoclassInfoDB] = useState([]);
  useEffect(() => {
    const fetchClassInfo = async () => {
      try {
        const res = await axios.get(
          'https://teachernote.me/api/classinfo/' + userId,
        );
        await setClassInfoclassInfoDB(res.data);
      } catch (err) {
        console.log(err);
      }
    };
    fetchClassInfo();
  }, [userId]);

  // console.log(JSON.stringify(classInfoDB));

  //---------------- 진도노트 삭제, 업데이트  ----------------//
  //진도노트 삭제
  const navigate = useNavigate();
  const deleteProgressNote = (noteId) => {
    if (!userId) {
      alert('로그인 후 이용가능합니다.');
      if (!isMobile) {
        setRegisterModalOpen(true);
      } else {
        navigate('/m-sign-up');
      }
    } else {
      const userConfirmed = window.confirm('진도 노트를 삭제하시겠습니까?');
      if (userConfirmed) {
        try {
          axios
            .delete('https://teachernote.me/api/deleteprogressnote/' + userId, {
              data: { noteId: noteId },
            })
            .then(() => {
              fetchProgressNoteByGrade();
            });
          // console.log('삭제');
        } catch (err) {
          console.log(err);
        }
      } else {
        // 사용자가 취소를 선택한 경우
      }
    }
  };

  //진도노트 업데이트
  const updateRecord = async (noteId, noteDate, noteRecord) => {
    if (!userId) {
      alert('로그인 후 이용가능합니다.');
      if (!isMobile) {
        setRegisterModalOpen(true);
      } else {
        navigate('/m-sign-up');
      }
    } else {
      try {
        await axios
          .put('https://teachernote.me/api/updateprogressnote/' + userId, {
            noteId: noteId,
            noteDate: noteDate,
            noteRecord: noteRecord,
          })
          .then(() => {
            fetchProgressNoteByGrade();
          });
        setShowNotification(true); // 알림 상태를 true로 변경
        setTimeout(() => {
          setShowNotification(false); // 3초 후에 알림 상태를 false로 변경하여 알림 사라지게 함
        }, 1000);
      } catch (err) {
        console.log(err);
      }
    }
  };

  const ToggleAddWindow = useCallback(() => {
    setShowAddWindow((prev) => !prev);
  }, [setShowAddWindow]);

  const isMobile = useMediaQuery({ maxWidth: 767 });

  //--------------------- 로그인/회원가입 --------------------//
  //회원가입 모달
  const [isRegisterModalOpen, setRegisterModalOpen] = useState(false);
  const [isLoginModalOpen, setLoginModalOpen] = useState(false);
  const [modalSource, setModalSource] = useState('bottombutton'); //menubar,bottombutton

  const handleAuthComplete = async (userId) => {
    setRegisterModalOpen(false);
    setLoginModalOpen(false);
  };

  const openRegisterModal = () => {
    setLoginModalOpen(false);
    setRegisterModalOpen(true);
  };

  const openLoginModal = () => {
    setRegisterModalOpen(false);
    setLoginModalOpen(true);
  };

  const closeAuthModal = () => {
    setRegisterModalOpen(false);
    setLoginModalOpen(false);
  };

  return (
    <>
      <ProgressNoteHelmetContent />{' '}
      <RegisterModalComponent
        isRegisterModalOpen={isRegisterModalOpen}
        setRegisterModalOpen={setRegisterModalOpen}
        openRegisterModal={openRegisterModal}
        openLoginModal={openLoginModal}
        closeModal={closeAuthModal}
        handleAuthComplete={handleAuthComplete}
        modalSource={modalSource}
      />
      {isLoginModalOpen ? (
        <LoginModalComponent
          isLoginModalOpen={isLoginModalOpen}
          setLoginModalOpen={setLoginModalOpen}
          openRegisterModal={openRegisterModal}
          openLoginModal={openLoginModal}
          closeAuthModal={closeAuthModal}
          handleAuthComplete={handleAuthComplete}
          modalSource={modalSource}
        />
      ) : (
        <></>
      )}
      <PageContainer>
        <PageSubheader>
          <ClassProgressnoteMenu
            classInfo={classInfoDB}
            showAddWindow={showAddWindow}
            setShowAddWindow={setShowAddWindow}
          />
        </PageSubheader>
        {isMobile && (
          <MobileTopMenuBarProgressNote setShowAddWindow={setShowAddWindow} />
        )}

        <PageBox>
          <Notification
            message="변경사항 저장 완료"
            isVisible={showNotification}
          />
          <Notification
            message="이 노트는 샘플입니다. 진도노트를 추가해보세요!"
            isVisible={showSampleNotification}
          />
          <TitleContainer>
            <DisplayRowSpaceBetween>
              <DisplayColumn>
                {' '}
                <TitleText>진도노트</TitleText>{' '}
                <TitleDetail>
                  진도표에서 작성한 진도노트를 확인하고, 추가 및 수정할 수
                  있습니다.
                </TitleDetail>
              </DisplayColumn>
            </DisplayRowSpaceBetween>
          </TitleContainer>
          <ByClassProgressNoteContainer
            sortedProgressNoteByGrade={sortedProgressNoteByGradeDB}
            topics={topicsDB}
            classInfoByGrade={classInfoByGradeDB}
            deleteProgressNote={deleteProgressNote}
            updateRecord={updateRecord}
            showAddWindow={showAddWindow}
            setShowAddWindow={setShowAddWindow}
            fetchProgressNoteByGrade={fetchProgressNoteByGrade}
            setShowNotification={setShowNotification}
            setShowSampleNotification={setShowSampleNotification}
            setRegisterModalOpen={setRegisterModalOpen}
          />
        </PageBox>
      </PageContainer>
    </>
  );
};

export default ByClassProgressNotePage;
